module.exports = __webpack_public_path__ + "img/lubo_summary_Image.de161be9.png";